import $ from 'jquery';

export default class CollapseItem {
    constructor(el) {
        this.DOM = {el: el};
        this.DOM.collapse = document.querySelector(this.DOM.el.dataset.collapseItem);

        this.initEvents();
    }

    initEvents() {
        /* Add event listener */
        $(this.DOM.collapse).on('show.bs.collapse', () => {
            this.DOM.el.classList.add("collapse-show");
        });
        $(this.DOM.collapse).on('hide.bs.collapse', () => {
            this.DOM.el.classList.remove("collapse-show");
        });
    }
}

const collapseItemNodes = Array.from(document.querySelectorAll('[data-collapse-item]'));
if (collapseItemNodes !== null) {
    collapseItemNodes.forEach((node) => { new CollapseItem(node); });
}
